export default __webpack_public_path__ + "static/media/i.2282ccf3.svg";